import { render } from "./SectionCardSmall.vue?vue&type=template&id=8999cee0"
import script from "./SectionCardSmall.vue?vue&type=script&lang=js"
export * from "./SectionCardSmall.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__